import { useCallback, type ComponentProps } from 'react';
import { TextInput } from '@astryxdesign/core/TextInput';

/**
 * Телефон на базе Astryx TextInput. В версии 0.6.3 TextInput поддерживает только
 * type text/password/email и не принимает inputMode, поэтому цифровая клавиатура
 * включается атрибутом на реальном input через ref.
 */
export function PhoneInput(props: Omit<ComponentProps<typeof TextInput>, 'type' | 'ref'>) {
  const ref = useCallback((el: HTMLInputElement | null) => {
    el?.setAttribute('inputmode', 'tel');
  }, []);
  return <TextInput {...props} ref={ref} type="text" autoComplete={props.autoComplete ?? 'tel'} />;
}
